import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import Blog from "./sections/Blog";
import Blogcategories from "./sections/Blogcategories";
import GarageCallToAction from "./sections/GarageCallToAction";
export default function BlogPage() {
  return <div>
      <Header />
      <GarageHero />
      <Blog />
      <Blogcategories />
      <GarageCallToAction />
    </div>;
}